import getConfig from 'next/config';
import Rollbar from 'rollbar';

import {ResponseError} from '~/src/utilities/types/error';

const {publicRuntimeConfig: config} = getConfig();

const rollbarConfig = {
    accessToken: config.rollbar.accessToken,
    captureUncaught: false,
    captureUnhandledRejections: false,
    enabled: !!config.rollbar.accessToken,
    payload: {
        environment: config.rollbar.environment
    },
    reportLevel: config.rollbar.environment === 'production' ? 'warning' : 'info',
    verbose: config.rollbar.environment === 'development',
    checkIgnore: (isUncaught, params) => {
        const [label, ...args] = params;
        if (!isUncaught) {
            for (let arg of args) {
                /**
                 * As we are currently discussing refactors to error tracking and the messages we send,
                 * the following text string is as is for now, and needs to be refactored later
                 *
                 * PD-1117: filter all activity service related 404s
                 * rollbar.error('Invalid activity item received', ...)
                 */
                if (label === 'Invalid activity item received' && arg instanceof ResponseError && arg.statusCode === 404) {
                    return true;
                }
            }
        }

        /**
         * PD-1274: filter issues caused by the legacy app
         * PD-1727: improve tracking filtering
         */
        const legacyKeywords = [
            '$',
            'offsetTop',
            'zattooInlinePlayerDisplayFinished',
            'manageAspectHeightElement',
            'resizeTopElementGallery',
            'updateActionBoxShareNumber',
            'sas_rectangle',
            "(near '...(null)...')",
            'getBoundingClientRect'
        ];
        if (legacyKeywords.some((keyword) => label.indexOf(keyword) !== -1)) {
            return true;
        }

        /**
         * PD-1715: filter errors most likely caused by ad blockers
         * PD-1727: remove rollbar notification (twitter, instagram, facebook)
         */
        const filteredDependencyErrors = [
            'Error while loading totm dependency',
            'Error while loading gtm dependency',
            'Error while loading beagle dependency',
            'Error while loading twitter embed',
            'Error while loading facebook embed',
            'Error while loading instagram embed'
        ];
        if (filteredDependencyErrors.some((entry) => entry === label)) {
            return true;
        }

        /**
         * PD-1715: filter 4xx http status codes
         */
        const possibleHttpStatus = label.slice(0, 3);
        if (possibleHttpStatus >= 400 && possibleHttpStatus < 500) {
            return true;
        }

        return false;
    }
};

// configure what resources are permitted to log errors
if (process.browser) {
    rollbarConfig.hostWhiteList = [];
    rollbarConfig.hostWhiteList.push(window.location.host);

    if (config.rollbar.hostWhiteList) {
        rollbarConfig.hostWhiteList.push(...config.rollbar.hostWhiteList.split(','));
    }
}

const rollbar = process.browser ? Rollbar.init(rollbarConfig) : new Rollbar(rollbarConfig);

export default rollbar;
